export const ActivitiesSkip = 0
export const ActivitiesTake = 20
